module.exports = __webpack_public_path__ + "img/passwordlock.cc0dcccd.svg";